var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 290,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: -45,
    y: 15,
    fontSize: "17px",
    fill: "transparent"
  }, "Change Language")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeLang);
export default __webpack_public_path__ + "static/media/changeLang.9a2692bd64acc3a923d138ce5f6098b2.svg";
export { ForwardRef as ReactComponent };